import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Status from "./routes/SyncStatus";
import History from "./routes/SyncHistory";

export default store => ({
  path: "sync",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "AssociatedCourses" */ "./components"),
      import(
        /* webpackChunkName: "AssociatedCourses" */ "./modules/AssociatedCoursesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;
      const reducerName = importedModule1.NAME;

      injectReducer(store, {
        key: reducerName,
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [Status(store), History(store)],
});
